import { ControllerRootOptions } from '../controller-classes';
import { noteData } from './note.data';
import { Notes } from './notes.class';
import { KitchenDesignBase, KitchenDesignOptions } from '../blueprint-classes/kitchen-design-base';
import { BlueprintInstanceType } from '../blueprint-classes/shared.enums';


import { NoteData, NoteDataIn, NoteParams } from './types';
import { NoteInstanceType, NoteType } from './shared.enums';

export class Note extends KitchenDesignBase<NoteDataIn> {
	#id: string;
	#createdBy: string;
	#createDate: string;
	#artifactId: string;
	#message: string;
	#type: NoteType;
	#parent: Note;
	#deleted: boolean;
	#deletedBy: string;
	#deleteDate: string;
	#currentUser: string;

	constructor (contextEmail: string, params: NoteParams | null = null, options: KitchenDesignOptions<NoteDataIn> = {}) {
		super(BlueprintInstanceType.Note, {});
		const data = noteData(contextEmail, params, options.dataIn || null);

		this.#id = data.id;
		this.#createdBy = data.createdBy;
		this.#createDate = data.createDate;
		this.#artifactId = data.artifactId;
		this.#message = data.message;
		this.#type = data.type;
		this.#deleted = false;
		this.#deletedBy = data.deletedBy;
		this.#deleteDate = data.deleteDate;
	}

	get id (): string { return this.#id }
	get createdBy (): string { return this.#createdBy }
	get createDate (): Date { return new Date(this.#createDate) }
	get artifactId (): string { return this.#artifactId }
	get message (): string { return this.#message }
	get type (): NoteType { return this.#type }
	get parent (): Note { return this.#parent }
	get deleted (): boolean { return this.#deleted }
	get deletedBy (): string { return this.#deletedBy }
	get deleteDate (): Date { return new Date(this.#deleteDate) }

	public delete (): void {
		this.#deleted = true;
		this.#deletedBy = this.#currentUser;
		this.#deleteDate = new Date().toISOString();
	}

	public reply (message: string): Note {
		// add note to parent
		const notes = this.findParentInstanceOf(BlueprintInstanceType.Notes) as unknown as Notes;
		const note = new Note(this.#currentUser, { message, artifactId: this.#artifactId, parent: this });
		notes.add(note);

		return note;
	}

	public serialize (): NoteData {
		return {
			id: this.#id,
			createdBy: this.#createdBy,
			createDate: this.#createDate,
			artifactId: this.#artifactId,
			message: this.#message,
			type: this.#type,
			parent: this.#parent,
			deletedBy: this.#deletedBy,
			deleteDate: this.#deleteDate,
			currentUser: this.#currentUser
		};
	}
}
